import React, { useState, Context, ReactElement, Component } from "react";

export interface quota_type {
    kind: string;
    items: quota_type_item[];
}

export interface quota_type_item {
    kind: string;
    apiVersion: string;
    metadata: {
        name: string;
        uid: string;
        isSelected: number;
        rootfs: number;
        labels: {
            workspace: string;
        };
        limitCPU?: string;
        limitMemory?: string;
        limitsRootfs?: string;
        limitsPod?: string;
        limitsDisk?: string;
    };

    spec: {
        finalizers: string[];
        workspacequota: string;
        description: string;
        cpulimitused: string;
        memorylimitlused: string;
        namespaces: object[];
        quotas: {
            quotaName?: string;
            requestCPU?: string;
            limitCPU?: string;
            requestMemory?: string;
            limitMemory?: string;
            requestRootfs?: string;
            limitsRootfs?: string;
            limitsPod?: string;
            limitsDisk?: string;
            pods?: string;
            gpu?: string;
            'requests.storage'?: string;
            'persistentvolumeclaims'?: string;
            'services'?: string;
            'secrets'?: string;
            'configmaps'?: string;
        }
    }
    status: {
        phase: string;
    };
}

const QuotaContext: Context<[quota_type['items'], React.Dispatch<React.SetStateAction<quota_type['items']>>]> = React.createContext<[quota_type['items'], React.Dispatch<React.SetStateAction<quota_type['items']>>]>([[] as unknown as quota_type['items'], (_value: any) => { }]);

const QuotaProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const [quotas, set_quotas]: [quota_type['items'], React.Dispatch<React.SetStateAction<quota_type['items']>>] = useState([] as unknown as quota_type['items']);

    return (
        <QuotaContext.Provider value={[quotas, set_quotas]}>
            {props.children}
        </QuotaContext.Provider>
    )
}

export { QuotaContext, QuotaProvider };

